import { reportRoutes } from "./report-routes";

export default (router: any) => {
  reportRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
